import { render } from "./product-usp-list.vue?vue&type=template&id=3b6f0934"
import script from "./product-usp-list.vue?vue&type=script&lang=js"
export * from "./product-usp-list.vue?vue&type=script&lang=js"

import "./product-usp-list.vue?vue&type=style&index=0&id=3b6f0934&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__